import settingsPage from './settingsPage';

export default {
    settingsPage,
};
